import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TableColumn, DataTableComponent } from '../data-table/data-table.component';
import { MatIcon } from "@angular/material/icon";

export interface ChangelogDialogConfig {
  title?: string;
  subtitle?: string;
  apiEndpoint: string;
  columns: TableColumn[];
  backButtonText?: string;
  alternateRowColors?: boolean;
}

@Component({
  selector: 'app-changelog-dialog',
  templateUrl: './changelog-dialog.component.html',
  styleUrls: ['./changelog-dialog.component.less'],
  imports: [MatIcon, DataTableComponent],
  standalone: true
})
export class ChangelogDialogComponent implements OnInit {
  records: any[] = [];
  loading = true;
  
  title: string;
  subtitle: string;
  columns: TableColumn[];
  backButtonText: string;
  alternateRowColors: boolean;

  constructor(
    private readonly http: HttpClient,
    @Inject('BASE_URL') private readonly baseUrl: string,
    @Inject(MAT_DIALOG_DATA) public data: ChangelogDialogConfig,
    private readonly dialogRef: MatDialogRef<ChangelogDialogComponent>
  ) {
    this.title = data.title || 'Change Log';
    this.subtitle = data.subtitle || '';
    this.columns = data.columns;
    this.backButtonText = data.backButtonText || 'Back';
    this.alternateRowColors = data.alternateRowColors || false;
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.http
      .get<any[]>(`${this.baseUrl}${this.data.apiEndpoint}`)
      .subscribe({
        next: (response) => {
          this.records = response || [];
          this.loading = false;
        },
        error: (error) => {
          console.error('Error loading changelog:', error);
          this.loading = false;
        }
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}

